import React from 'react';
import FacebookLogin from 'react-facebook-login';
import axios from 'axios';

const FacebookShare = () => {
  const handleFacebookLogin = async (response) => {
    if (response.status === 'connected') {
      const { accessToken } = response.authResponse;
      const imageURL = ""
      const caption = 'UE COMIX TEST';

      try {
        const postResponse = await axios.post(
          `https://graph.facebook.com/me/photos?access_token=${accessToken}`,
          { url: imageURL, caption: caption }
        );
        console.log('Image posted on Facebook:', postResponse.data);
      } catch (error) {
        console.error('Error posting image on Facebook:', error);
      }
    } else {
      console.log('User cancelled login or did not authorize.');
    }
  };

  return (
    <div>
      <FacebookLogin
        appId="1074513296970458"
        autoLoad={false}
        fields="name,email,picture"
        callback={handleFacebookLogin}
      />
    </div>
  );
};

export default FacebookShare;
